(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PortDeleteController',PortDeleteController);

    PortDeleteController.$inject = ['$uibModalInstance', 'entity', 'Port'];

    function PortDeleteController($uibModalInstance, entity, Port) {
        var vm = this;

        vm.port = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Port.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
